import { useQuery, useQueryClient } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { cabinetApi } from '../api'
import { savedViewLink } from './savedViewQuery'
import { useT } from '../i18n'

/** Сегодня календарём UTC — тем же, в котором живут даты прогноза. */
const today = () => new Date().toISOString().slice(0, 10)

export function SavedViews() {
  const t = useT()
  const qc = useQueryClient()
  const { data, isLoading } = useQuery({
    queryKey: ['cabinet', 'saved-views'],
    queryFn: () => cabinetApi.savedViews(),
  })

  if (isLoading) return <p className="text-sm text-mist">{t('common.loading')}</p>
  const views = data?.saved_views ?? []
  if (views.length === 0) {
    return (
      <p className="text-sm text-mist">
        {t('settings.savedViews.empty')}
      </p>
    )
  }

  return (
    <ul className="max-w-lg divide-y divide-hull">
      {views.map(v => {
        // url_state может быть частичным — ссылку собираем терпимо (раздел +
        // контекст + слой + наложения + флот); старые виды без новых ключей
        // открываются на дефолтах. Дата пересчитывается от сегодняшнего дня по
        // смещению: вид, сохранённый на завтра, завтрашним и открывается.
        const link = savedViewLink(v.url_state, v.created_at, today())
        return (
          <li key={v.id} className="flex items-center justify-between py-2">
            <Link to={`${link.path}?${link.query}`} className="text-sm text-sonar hover:underline">
              {v.name}
            </Link>
            <button
              type="button"
              onClick={async () => {
                await cabinetApi.deleteSavedView(v.id)
                qc.invalidateQueries({ queryKey: ['cabinet', 'saved-views'] })
              }}
              className="text-xs text-coral hover:underline"
            >
              {t('common.remove')}
            </button>
          </li>
        )
      })}
    </ul>
  )
}
